import React from "react";
import styles from "./SupplyBurn.module.scss";
import Image from "next/image";

const SupplyBurn = () => {
  return (
    <section className={styles.supplyBurn}>
      <div className={styles.blobBottom} />
      <Image
        src="/assets/Image/fireCoin1.png"
        width={91}
        height={141}
        alt="image"
        className={styles.imageFire}
      />
      <Image
        src="/assets/Image/fireCoin3.png"
        width={135}
        height={213}
        alt="image"
        className={styles.imageFire2}
      />
      <Image
        src="/assets/Image/fireCoin2.png"
        width={135}
        height={213}
        alt="image"
        className={styles.imageFire3}
      />

      <div className={styles.container}>
        <div className={styles.content}>
          <h1 className={styles.title}>10% Supply Burn</h1>
          <p className={styles.text}>
            The supply of B-Love tokens will be controlled by burning mechanism.
            Each month, 10% of the initial supply will be burned.
          </p>
          <p className={styles.text}>
            With the passive burning on monthly basis, the internal price of
            B-Love tokens will continue to increase.
          </p>
        </div>

        <div className={styles.image}>
          <Image
            src="/assets/Image/firecoins.png"
            alt="image"
            width={525}
            height={420}
          />
        </div>
      </div>
    </section>
  );
};

export default SupplyBurn;
